import React from 'react';
import FranchisePreview from './FranchisePreview'

const CustomOption = ({ innerRef, innerProps, value, label, data }) => (
  <div {...innerProps} ref={innerRef} >
    <FranchisePreview data={data} />
  </div>
)

export default CustomOption;
